// When a conflicting commit hash is found, we want to clear some persistent vars from the local cache.
// This dict defines whitelist/blacklist partials. Note: whitelist trumps blacklist
const clearPersistStore = {
    whitelist: [
        // defines items which should NOT be cleared
        "reduxPersist:authentication"
    ],
    blacklist: [
        // defines (partial) items which SHOULD be cleared
        "reduxPersist:"
    ]
};

// Function is used to clean the localStorage based on some parameters for cleaning
export function cleanLocalStorage(commitHash) {
    Object.keys(localStorage).forEach((key) => {
        const blacklisted = clearPersistStore.blacklist.some((blacklist) => key.includes(blacklist));
        const whitelisted = clearPersistStore.whitelist.some((whitelist) => key.includes(whitelist));
        const remove = blacklisted && !whitelisted;
        if (remove) {
            localStorage.removeItem(key);
        }
    });

    localStorage.setItem("commitHash", commitHash);
}
